"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.webSearch.name': 'Web Search',
    'tools.webSearch.description': 'Search the internet for current information',
};
